import {
  cn
} from "./chunk-DYSUVPH5.mjs";

// src/components/icon-button/icon-button.tsx
import React, { forwardRef } from "react";
var IconButton = forwardRef(
  ({ children, className, ...props }, forwardedRef) => {
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        ref: forwardedRef,
        className: cn(
          "block rounded-md p-2 text-action-ghost-secondary-foreground transition-button duration-300 hover:bg-action-ghost-secondary-surface-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus disabled:cursor-not-allowed disabled:opacity-50",
          className
        ),
        ...props
      },
      children
    );
  }
);

export {
  IconButton
};
